import React from 'react'
import { useUserActivityLog } from '../hooks/useUserActivityLog.js'
import ActivityLogDrawer from './ActivityLogDrawer.js'

interface Props {
  userId: string | null
  userName?: string
  onClose: () => void
}

const UserActivityDrawer: React.FC<Props> = ({ userId, userName, onClose }) => {
  const activityLog = useUserActivityLog(userId)

  return (
    <ActivityLogDrawer
      entityId={userId}
      title="Activity Log"
      {...(userName ? { subtitle: userName } : {})}
      noSessionsLabel="No AI tool calls yet for this user."
      onClose={onClose}
      {...activityLog}
    />
  )
}

export default UserActivityDrawer
